import { HttpInterceptorFn } from '@angular/common/http';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  // Get language directly from localStorage to avoid circular dependency
  let langValue = 'EN';
  
  try {
    const savedLanguage = localStorage.getItem('preferredLanguage');
    if (savedLanguage === 'id') {
      langValue = 'IDN';
    }
  } catch (error) {
    // Fallback to 'EN' if localStorage is unavailable
  }
  
  const modifiedReq = req.clone({
    setHeaders: {
      'X-Language': langValue
    }
  });
  
  return next(modifiedReq);
};